var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.625,
    height: 21.625,
    viewBox: "0 0 21.625 21.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Checked",
    d: "M12.468,24.472a10.356,10.356,0,0,0,4.174-.851,11.085,11.085,0,0,0,5.787-5.787,10.7,10.7,0,0,0-.006-8.353,11.146,11.146,0,0,0-2.343-3.456,10.876,10.876,0,0,0-3.45-2.337,10.474,10.474,0,0,0-4.174-.84,10.434,10.434,0,0,0-4.168.84A11.054,11.054,0,0,0,2.5,9.481,10.7,10.7,0,0,0,2.5,17.834a11.137,11.137,0,0,0,5.787,5.787A10.344,10.344,0,0,0,12.468,24.472Zm0-1.981a8.663,8.663,0,0,1-3.439-.684,8.844,8.844,0,0,1-4.708-4.713,8.841,8.841,0,0,1,4.7-11.586,8.684,8.684,0,0,1,3.433-.679,8.836,8.836,0,0,1,6.266,15.08,8.868,8.868,0,0,1-2.816,1.9A8.663,8.663,0,0,1,12.468,22.491Zm-1.157-3.829a1,1,0,0,0,.89-.523l4.763-7.457a2.381,2.381,0,0,0,.178-.334.907.907,0,0,0,.078-.367.718.718,0,0,0-.278-.59.973.973,0,0,0-.623-.223.932.932,0,0,0-.79.5l-4.251,6.822L9.263,13.91a1.093,1.093,0,0,0-.378-.334.981.981,0,0,0-.423-.089.83.83,0,0,0-.618.256.858.858,0,0,0-.25.623,1.122,1.122,0,0,0,.256.69l2.526,3.083a1.435,1.435,0,0,0,.434.4A1.022,1.022,0,0,0,11.311,18.663Z",
    transform: "translate(-1.65 -2.848)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/Checked.f3e2531da0330b1b1b486f830508b39a.svg";
export { ForwardRef as ReactComponent };